/* Colors */
export const DEEP_PINK = '#ff1493'
export const ORANGE = '#ff6d39'
export const TURQUOISE = '#40e0d0'

/* System Colors */
export const PRIMARY_COLOR = ORANGE
